
import HeroSection from "@/components/LandingPage/HeroSection/index.vue";
import MarketsSection from "@/components/LandingPage/MarketsSection/index.vue";
import StakingSection from "@/components/LandingPage/StakingSection/index.vue";
import AppSection from "@/components/LandingPage/AppSection/index.vue";
import AboutSection from "@/components/LandingPage/AboutSection/index.vue";

export default {
	name: 'IndexPage',
	layout: 'landing',
	components: { HeroSection, MarketsSection, StakingSection, AppSection, AboutSection },
	head () {
		return {
			title: 'Enifex - Trade, Stake, Earn Crypto Anywhere | Trusted Gateway to Crypto Markets',
		};
	},
}
